import React, { act } from 'react';
import { createContext, useState, useContext, useEffect } from "react";
import foundImage from "../../images/found_img.png";
import { getAllMovies, getAllTvSeries, getItem } from "../repositories/movies_and_tvseries";
import { firebaseFirestore } from '../firebase/firebase_configuration';
import { doc, onSnapshot } from 'firebase/firestore';

const searchContext = createContext();

export const SearchProvider = ({ children }) => {
    const [getIsMessage, setIsMessage] = useState(false);
    const [getUserId, setUserId] = useState("");
    const [getYourId, setYourId] = useState("");
    const [getSelectedEmoji, setSelectedEmoji] = useState("");
    const [getUnknownTab, setUnknownTab] = useState("");

    const [getIsActionLoading, setIsActionLoading] = useState(true);
    const [getIsThrillerLoading, setIsThrillerLoading] = useState(true);
    const [getIsComedyLoading, setIsComedyLoading] = useState(true);
    const [getIsHorrorLoading, setIsHorrorLoading] = useState(true);
    const [getIsFamilyLoading, setIsFamilyLoading] = useState(true);
    const [getIsMysteryLoading, setIsMysteryLoading] = useState(true);
    const [getIsAnimationLoading, setIsAnimationLoading] = useState(true);
    const [getIsDramaLoading, setIsDramaLoading] = useState(true);
    const [getIsAdventureLoading, setIsAdventureLoading] = useState(true);
    const [getIsRomanceLoading, setIsRomanceLoading] = useState(true);
    const [getIsScienceFictionLoading, setIsScienceFictionLoading] = useState(true);
    const [getIsNewsLoading, setIsNewsLoading] = useState(true);
    const [getIsKidsLoading, setIsKidsLoading] = useState(true);
    const [getIsRealityLoading, setIsRealityLoading] = useState(true);
    const [getIsSoapLoading, setIsSoapLoading] = useState(true);
    const [getIsTalkLoading, setIsTalkLoading] = useState(true);
    const [getIsWarLoading, setIsWarLoading] = useState(true);
    const [getIsWesternLoading, setIsWesternLoading] = useState(true);
    const [getIsHistoryLoading, setIsHistoryLoading] = useState(true);
    const [getIsDocumentaryLoading, setIsDocumentaryLoading] = useState(true);
    const [getIsFantasyLoading, setIsFantasyLoading] = useState(true);
    const [getIsCrimeLoading, setIsCrimeLoading] = useState(true);
    const [getIsMusicLoading, setIsMusicLoading] = useState(true);
    const [getIsVotedLoading, setIsVotedLoading] = useState(true);

    // const [getSearch, setSearch] = useState("");
    const [getActionError, setActionError] = useState("");
    const [getThrillerError, setThrillerError] = useState("");
    const [getComedyError, setComedyError] = useState("");
    const [getHorrorError, setHorrorError] = useState("");
    const [getFamilyError, setFamilyError] = useState("");
    const [getMysteryError, setMysteryError] = useState("");
    const [getAnimationError, setAnimationError] = useState("");
    const [getDramaError, setDramaError] = useState("");
    const [getAdventureError, setAdventureError] = useState("");
    const [getRomanceError, setRomanceError] = useState("");
    const [getScienceFictionError, setScienceFictionError] = useState("");
    const [getNewsError, setNewsError] = useState("");
    const [getKidsError, setKidsError] = useState("");
    const [getRealityError, setRealityError] = useState("");
    const [getSoapError, setSoapError] = useState("");
    const [getTalkError, setTalkError] = useState("");
    const [getWarError, setWarError] = useState("");
    const [getWesternError, setWesternError] = useState("");
    const [getHistoryError, setHistoryError] = useState("");
    const [getDocumentaryError, setDocumentaryError] = useState("");
    const [getFantasyError, setFantasyError] = useState("");
    const [getCrimeError, setCrimeError] = useState("");
    const [getMusicError, setMusicError] = useState("");
    const [getVotedError, setVotedError] = useState("");

    const [getActionList, setActionList] = useState([]);
    const [getThrillerList, setThrillerList] = useState([]);
    const [getComedyList, setComedyList] = useState([]);
    const [getHorrorList, setHorrorList] = useState([]);
    const [getFamilyList, setFamilyList] = useState([]);
    const [getMysteryList, setMysteryList] = useState([]);
    const [getAnimationList, setAnimationList] = useState([]);
    const [getDramaList, setDramaList] = useState([]);
    const [getAdventureList, setAdventureList] = useState([]);
    const [getRomanceList, setRomanceList] = useState([]);
    const [getScienceFictionList, setScienceFictionList] = useState([]);
    const [getNewsList, setNewsList] = useState([]);
    const [getKidsList, setKidsList] = useState([]);
    const [getRealityList, setRealityList] = useState([]);
    const [getSoapList, setSoapList] = useState([]);
    const [getTalkList, setTalkList] = useState([]);
    const [getWarList, setWarList] = useState([]);
    const [getWesternList, setWesternList] = useState([]);
    const [getHistoryList, setHistoryList] = useState([]);
    const [getDocumentaryList, setDocumentaryList] = useState([]);
    const [getFantasyList, setFantasyList] = useState([]);
    const [getCrimeList, setCrimeList] = useState([]);
    const [getMusicList, setMusicList] = useState([]);
    const [getVotedList, setVotedList] = useState([]);

    const [getOriginalActionList, setOriginalActionList] = useState([]);
    const [getOriginalThrillerList, setOriginalThrillerList] = useState([]);
    const [getOriginalComedyList, setOriginalComedyList] = useState([]);
    const [getOriginalHorrorList, setOriginalHorrorList] = useState([]);
    const [getOriginalFamilyList, setOriginalFamilyList] = useState([]);
    const [getOriginalMysteryList, setOriginalMysteryList] = useState([]);
    const [getOriginalAnimationList, setOriginalAnimationList] = useState([]);
    const [getOriginalDramaList, setOriginalDramaList] = useState([]);
    const [getOriginalAdventureList, setOriginalAdventureList] = useState([]);
    const [getOriginalRomanceList, setOriginalRomanceList] = useState([]);
    const [getOriginalScienceFictionList, setOriginalScienceFictionList] = useState([]);
    const [getOriginalNewsList, setOriginalNewsList] = useState([]);
    const [getOriginalKidsList, setOriginalKidsList] = useState([]);
    const [getOriginalRealityList, setOriginalRealityList] = useState([]);
    const [getOriginalSoapList, setOriginalSoapList] = useState([]);
    const [getOriginalTalkList, setOriginalTalkList] = useState([]);
    const [getOriginalWarList, setOriginalWarList] = useState([]);
    const [getOriginalWesternList, setOriginalWesternList] = useState([]);
    const [getOriginalHistoryList, setOriginalHistoryList] = useState([]);
    const [getOriginalDocumentaryList, setOriginalDocumentaryList] = useState([]);
    const [getOriginalFantasyList, setOriginalFantasyList] = useState([]);
    const [getOriginalCrimeList, setOriginalCrimeList] = useState([]);
    const [getOriginalMusicList, setOriginalMusicList] = useState([]);
    const [getOriginalVotedList, setOriginalVotedList] = useState([]);

    const [getBackImages, setBackImages] = useState([
        foundImage,
        "https://reelentropy.com/wp-content/uploads/2019/07/mv5bm2vmzjbhngityty4yi00mdbmlwewzdmtyzhkmgjmywu2yzmyxkeyxkfqcgdeqxvymtkxnjuynq4040._v1_sx1777_cr001777999_al_.jpg?w=1024&h=216&crop=1",
    ]);

    const [getBackIndex, setBackIndex] = useState(0);
    const [getActionPageNumber, setActionPageNumber] = useState(1);
    const [getThrillerPageNumber, setThrillerPageNumber] = useState(1);
    const [getMysteryPageNumber, setMysteryPageNumber] = useState(1);
    const [getComedyPageNumber, setComedyPageNumber] = useState(1);
    const [getAnimationPageNumber, setAnimationPageNumber] = useState(1);
    const [getDramaPageNumber, setDramaPageNumber] = useState(1);
    const [getAdventurePageNumber, setAdventurePageNumber] = useState(1);
    const [getFamilyPageNumber, setFamilyPageNumber] = useState(1);
    const [getHorrorPageNumber, setHorrorPageNumber] = useState(1);
    const [getRomancePageNumber, setRomancePageNumber] = useState(1);
    const [getNewsPageNumber, setNewsPageNumber] = useState(1);
    const [getScienceFictionPageNumber, setScienceFictionPageNumber] = useState(1);
    const [getKidsPageNumber, setKidsPageNumber] = useState(1);
    const [getRealityPageNumber, setRealityPageNumber] = useState(1);
    const [getSoapPageNumber, setSoapPageNumber] = useState(1);
    const [getTalkPageNumber, setTalkPageNumber] = useState(1);
    const [getWarPageNumber, setWarPageNumber] = useState(1);
    const [getWesternPageNumber, setWesternPageNumber] = useState(1);
    const [getHistoryPageNumber, setHistoryPageNumber] = useState(1);
    const [getDocumentaryPageNumber, setDocumentaryPageNumber] = useState(1);
    const [getFantasyPageNumber, setFantasyPageNumber] = useState(1);
    const [getCrimePageNumber, setCrimePageNumber] = useState(1);
    const [getMusicPageNumber, setMusicPageNumber] = useState(1);

    const categories = [
        "action_movie", "action_series", "thriller_movie", "thriller_series", "comedy_movie", "comedy_series",
        "horror_movie", "horror_series", "family_movie", "family_series", "mystery_movie", "mystery_series",
        "animation_movie", "animation_series", "drama_movie", "drama_series", "adventure_movie", "adventure_series",
        "romance_movie", "romance_series", "science fiction_movie", "science fiction_series", "news_movie",
        "news_series", "kids_movie", "kids_series", "reality_movie", "reality_series", "soap_movie",
        "soap_series", "talk_movie", "talk_series", "war_movie", "war_series", "western_movie",
        "western_series", "history_movie", "history_series", "documentary_movie", "documentary_series",
        "fantasy_movie", "fantasy_series", "crime_movie", "crime_series", "music_movie", "music_series",
    ];

    const vote_map = {
        action_movie: [], action_series: [],
        thriller_movie: [], thriller_series: [],
        comedy_movie: [], comedy_series: [],
        horror_movie: [], horror_series: [],
        family_movie: [], family_series: [],
        mystery_movie: [], mystery_series: [],
        animation_movie: [], animation_series: [],
        drama_movie: [], drama_series: [],
        adventure_movie: [], adventure_series: [],
        romance_movie: [], romance_series: [],
        "science fiction_movie": [], "science fiction_series": [],
        news_movie: [], news_series: [],
        kids_movie: [], kids_series: [],
        reality_movie: [], reality_series: [],
        soap_movie: [], soap_series: [],
        talk_movie: [], talk_series: [],
        war_movie: [], war_series: [],
        western_movie: [], western_series: [],
        history_movie: [], history_series: [],
        documentary_movie: [], documentary_series: [],
        fantasy_movie: [], fantasy_series: [],
        crime_movie: [], crime_series: [],
        music_movie: [], music_series: [],
    }

    const genre_config = {
        thriller: {
          getList: getOriginalThrillerList,
          setOriginalList: setOriginalThrillerList,
          setList: setThrillerList,
          getPage: getThrillerPageNumber,
          setPage: setThrillerPageNumber,
          setLoading: setIsThrillerLoading,
          setError: setThrillerError,
        },
        mystery: {
          getList: getOriginalMysteryList,
          setOriginalList: setOriginalMysteryList,
          setList: setMysteryList,
          getPage: getMysteryPageNumber,
          setPage: setMysteryPageNumber,
          setLoading: setIsMysteryLoading,
          setError: setMysteryError,
        },
        family: {
          getList: getOriginalFamilyList,
          setOriginalList: setOriginalFamilyList,
          setList: setFamilyList,
          getPage: getFamilyPageNumber,
          setPage: setFamilyPageNumber,
          setLoading: setIsFamilyLoading,
          setError: setFamilyError,
        },
        horror: {
          getList: getOriginalHorrorList,
          setOriginalList: setOriginalHorrorList,
          setList: setHorrorList,
          getPage: getHorrorPageNumber,
          setPage: setHorrorPageNumber,
          setLoading: setIsHorrorLoading,
          setError: setHorrorError,
        },
        comedy: {
          getList: getOriginalComedyList,
          setOriginalList: setOriginalComedyList,
          setList: setComedyList,
          getPage: getComedyPageNumber,
          setPage: setComedyPageNumber,
          setLoading: setIsComedyLoading,
          setError: setComedyError,
        },
        animation: {
          getList: getOriginalAnimationList,
          setOriginalList: setOriginalAnimationList,
          setList: setAnimationList,
          getPage: getAnimationPageNumber,
          setPage: setAnimationPageNumber,
          setLoading: setIsAnimationLoading,
          setError: setAnimationError,
        },
        drama: {
          getList: getOriginalDramaList,
          setOriginalList: setOriginalDramaList,
          setList: setDramaList,
          getPage: getDramaPageNumber,
          setPage: setDramaPageNumber,
          setLoading: setIsDramaLoading,
          setError: setDramaError,
        },
        adventure: {
          getList: getOriginalAdventureList,
          setOriginalList: setOriginalAdventureList,
          setList: setAdventureList,
          getPage: getAdventurePageNumber,
          setPage: setAdventurePageNumber,
          setLoading: setIsAdventureLoading,
          setError: setAdventureError,
        },
        romance: {
          getList: getOriginalRomanceList,
          setOriginalList: setOriginalRomanceList,
          setList: setRomanceList,
          getPage: getRomancePageNumber,
          setPage: setRomancePageNumber,
          setLoading: setIsRomanceLoading,
          setError: setRomanceError,
        },
        science_fiction: {
          getList: getOriginalScienceFictionList,
          setOriginalList: setOriginalScienceFictionList,
          setList: setScienceFictionList,
          getPage: getScienceFictionPageNumber,
          setPage: setScienceFictionPageNumber,
          setLoading: setIsScienceFictionLoading,
          setError: setScienceFictionError,
        },
        news: {
          getList: getOriginalNewsList,
          setOriginalList: setOriginalNewsList,
          setList: setNewsList,
          getPage: getNewsPageNumber,
          setPage: setNewsPageNumber,
          setLoading: setIsNewsLoading,
          setError: setNewsError,
        },
        action: {
          getList: getOriginalActionList,
          setOriginalList: setOriginalActionList,
          setList: setActionList,
          getPage: getActionPageNumber,
          setPage: setActionPageNumber,
          setLoading: setIsActionLoading,
          setError: setActionError,
        },
        kids: {
            getList: getOriginalKidsList,
            setOriginalList: setOriginalKidsList,
            setList: setKidsList,
            getPage: getKidsPageNumber,
            setPage: setKidsPageNumber,
            setLoading: setIsKidsLoading,
            setError: setKidsError,
        },
        reality: {
            getList: getOriginalRealityList,
            setOriginalList: setOriginalRealityList,
            setList: setRealityList,
            getPage: getRealityPageNumber,
            setPage: setRealityPageNumber,
            setLoading: setIsRealityLoading,
            setError: setRealityError,
        },
        soap: {
            getList: getOriginalSoapList,
            setOriginalList: setOriginalSoapList,
            setList: setSoapList,
            getPage: getSoapPageNumber,
            setPage: setSoapPageNumber,
            setLoading: setIsSoapLoading,
            setError: setSoapError,
        },
        talk: {
            getList: getOriginalTalkList,
            setOriginalList: setOriginalTalkList,
            setList: setTalkList,
            getPage: getTalkPageNumber,
            setPage: setTalkPageNumber,
            setLoading: setIsTalkLoading,
            setError: setTalkError,
        },
        war: {
            getList: getOriginalWarList,
            setOriginalList: setOriginalWarList,
            setList: setWarList,
            getPage: getWarPageNumber,
            setPage: setWarPageNumber,
            setLoading: setIsWarLoading,
            setError: setWarError,
        },
        western: {
            getList: getOriginalWesternList,
            setOriginalList: setOriginalWesternList,
            setList: setWesternList,
            getPage: getWesternPageNumber,
            setPage: setWesternPageNumber,
            setLoading: setIsWesternLoading,
            setError: setWesternError,
        },
        history: {
            getList: getOriginalHistoryList,
            setOriginalList: setOriginalHistoryList,
            setList: setHistoryList,
            getPage: getHistoryPageNumber,
            setPage: setHistoryPageNumber,
            setLoading: setIsHistoryLoading,
            setError: setHistoryError,
        },
        fantasy: {
            getList: getOriginalFantasyList,
            setOriginalList: setOriginalFantasyList,
            setList: setFantasyList,
            getPage: getFantasyPageNumber,
            setPage: setFantasyPageNumber,
            setLoading: setIsFantasyLoading,
            setError: setFantasyError,
        },
        documentary: {
            getList: getOriginalDocumentaryList,
            setOriginalList: setOriginalDocumentaryList,
            setList: setDocumentaryList,
            getPage: getDocumentaryPageNumber,
            setPage: setDocumentaryPageNumber,
            setLoading: setIsDocumentaryLoading,
            setError: setDocumentaryError,
        },
        crime: {
            getList: getOriginalCrimeList,
            setOriginalList: setOriginalCrimeList,
            setList: setCrimeList,
            getPage: getCrimePageNumber,
            setPage: setCrimePageNumber,
            setLoading: setIsCrimeLoading,
            setError: setCrimeError,
        },
        music: {
            getList: getOriginalMusicList,
            setOriginalList: setOriginalMusicList,
            setList: setMusicList,
            getPage: getMusicPageNumber,
            setPage: setMusicPageNumber,
            setLoading: setIsMusicLoading,
            setError: setMusicError,
        },
    };

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.toLocaleDateString('en-US', {
        month: 'long',
    });
    const date = `${currentMonth.toLowerCase()}_${currentYear}`;

    const getVotedItems = async () => {
        try {
            const votedItemsRef = doc(firebaseFirestore, "User Votes", date);
            const unsubscribe = onSnapshot(votedItemsRef, async (voteItemsDocs) => {
                let votedItemsSet = [];
                if (voteItemsDocs.exists()) {
                    const votedItemsData = voteItemsDocs.data();
                    Object.keys(votedItemsData).forEach((fieldName) => {
                        const field = votedItemsData[fieldName];
                        Object.entries(field).forEach(([key, value]) => {
                            // if (!votedItemsSet.includes(value)) {
                            //     votedItemsSet.push(value);
                            // }
                            Object.entries(vote_map).forEach(([itemKey, itemValue]) => {
                                if (itemKey == key) {
                                    itemValue.push(
                                        {
                                            tagId: key,
                                            itemId: value,
                                        }
                                    );
                                };
                            });
                        });
                    });

                    Object.entries(vote_map).forEach(([voteKey, voteValue]) => {
                        const countMap = {};
                        let maxItem = null;
                        let maxCount = 0;
                        let tag = "";

                        for (const item of voteValue) {
                            countMap[item["itemId"]] = (countMap[item["itemId"]] || 0) + 1;
                            tag = item["tagId"];
                        }

                        for (const item in countMap) {
                            if (countMap[item] > maxCount) {
                                maxCount = countMap[item];
                                maxItem = item;
                            }
                        }

                        if (maxItem != null) {
                            votedItemsSet.push(
                                {
                                    tag: tag,
                                    item: maxItem,
                                }
                            );
                        }
                    })
                };
    
                const updateList = await Promise.all(
                    votedItemsSet.map(async (item) => {
                        let newGenreList = [];
                        const itemId = item.item.split("_")[1];
                        const itemType = item.item.split("_")[0];
                        const details = await getItem({ itemId, type: itemType === "movie" ? itemType : "tv" });

                        details["genres"].forEach((result) => {
                            const isDuplicate = newGenreList.some(item => item.name === result.name);
                            if (!isDuplicate) {
                                newGenreList.push({
                                    name: result.name,
                                });
                            }
                        });

                        const genreNames = newGenreList.map(item => item.name);
                        return { 
                            ...item.item, 
                            id: itemId,
                            type: itemType,
                            name: `${itemType === "movie" ? details.title : details.name}`, 
                            image: details.poster_path,
                            genre: `${genreNames[0] === "" || genreNames[0] == null ? "action" : genreNames[0].toLowerCase()}`,
                            overview: details.overview,
                            section: item.tag,
                        };
                    })
                );
    
                setVotedList(updateList);
                setOriginalVotedList(updateList);
                setIsVotedLoading(false);
            });
    
            return() => unsubscribe();
        } catch (error) {
            console.log(error.message);
            setVotedError("Error...");
        };
    };

    const getAllGenre = async (genreMovie, genreSeries, type) => {
        const config = genre_config[type] || genre_config["action"];
        config.setLoading(true);
      
        const currentList = config.getList;
        const currentPage = config.getPage;
      
        try {
            const [movies, series] = await Promise.all([
                getAllMovies({ genreId: genreMovie, pageNumber: currentPage }),
                getAllTvSeries({ genreId: genreSeries, pageNumber: currentPage })
            ]);
        
            const existingIds = new Set(currentList.map(item => item.id));
            const combinedResults = [];
        
            const addUniqueItems = (items, isMovie = true) => {
                items.forEach(item => {
                if (!existingIds.has(item.id)) {
                    existingIds.add(item.id);
                    if (item.backdrop_path) getBackImages.push(`https://image.tmdb.org/t/p/w500${item.backdrop_path}`);
                    combinedResults.push({
                        id: item.id,
                        title: isMovie ? item.title : item.name,
                        poster_path: item.poster_path,
                        type: isMovie ? "movie" : "series"
                    });
                }
                });
            };
        
            addUniqueItems(movies.results, true);
            addUniqueItems(series.results, false);
        
            config.setOriginalList(prev => [...prev, ...combinedResults]);
            config.setList(prev => [...prev, ...combinedResults]);
            // if (currentPage <= 100) {
            //     config.setPage(prev => prev + 1);
            // }

            config.setPage(prev => prev + 1);
        } catch (error) {
            console.error(`Error loading ${type} genre:`, error.message);
            config.setError(`Error...: ${error.message}`);
        } finally {
            config.setLoading(false);
        }
    }

    useEffect(() => {
        getVotedItems();
    }, [date]);

    useEffect(() => {
        if (getActionPageNumber <= 100) {
            getAllGenre(28, 10759, "action");
        }
    }, [getActionPageNumber]);

    useEffect(() => {
        if (getThrillerPageNumber <= 100) {
            getAllGenre(53, 53, "thriller");
        }
    }, [getThrillerPageNumber]);

    useEffect(() => {
        if (getMysteryPageNumber <= 100) {
            getAllGenre(9648, 9648, "mystery");
        }
    }, [getMysteryPageNumber]);

    useEffect(() => {
        if (getFamilyPageNumber <= 100) {
            getAllGenre(10751, 10751, "family");
        }
    }, [getFamilyPageNumber]);

    useEffect(() => {
        if (getHorrorPageNumber <= 100) {
            getAllGenre(27, 27, "horror");
        }
    }, [getHorrorPageNumber]);

    useEffect(() => {
        if (getComedyPageNumber <= 100) {
            getAllGenre(35, 35, "comedy");
        }
    }, [getComedyPageNumber]);

    useEffect(() => {
        if (getAnimationPageNumber <= 100) {
            getAllGenre(16, 16, "animation");
        }
    }, [getAnimationPageNumber]);

    useEffect(() => {
        if (getDramaPageNumber <= 100) {
            getAllGenre(18, 18, "drama");
        }
    }, [getDramaPageNumber]);

    useEffect(() => {
        if (getAdventurePageNumber <= 100) {
            getAllGenre(12, 12, "adventure");
        }
    }, [getAdventurePageNumber]);

    useEffect(() => {
        if (getRomancePageNumber <= 100) {
            getAllGenre(10749, 10749, "romance");
        }
    }, [getRomancePageNumber]);

    useEffect(() => {
        if (getScienceFictionPageNumber <= 100) {
            getAllGenre(878, 10765, "science_fiction");
        }
    }, [getScienceFictionPageNumber]);

    useEffect(() => {
        if (getNewsPageNumber <= 100) {
            getAllGenre(10763, 10763, "news");
        }
    }, [getNewsPageNumber]);

    useEffect(() => {
        if (getKidsPageNumber <= 100) {
            getAllGenre(10762, 10762, "kids");
        }
    }, [getKidsPageNumber]);

    useEffect(() => {
        if (getRealityPageNumber <= 100) {
            getAllGenre(10764, 10764, "reality");
        }
    }, [getRealityPageNumber]);

    useEffect(() => {
        if (getSoapPageNumber <= 100) {
            getAllGenre(10766, 10766, "soap");
        }
    }, [getSoapPageNumber]);

    useEffect(() => {
        if (getTalkPageNumber <= 100) {
            getAllGenre(10767, 10767, "talk");
        }
    }, [getTalkPageNumber]);

    useEffect(() => {
        if (getWarPageNumber <= 100) {
            getAllGenre(10752, 10768, "war");
        }
    }, [getWarPageNumber]);

    useEffect(() => {
        if (getWesternPageNumber <= 100) {
            getAllGenre(37, 37, "western");
        }
    }, [getWesternPageNumber]);

    useEffect(() => {
        if (getHistoryPageNumber <= 100) {
            getAllGenre(36, 36, "history");
        }
    }, [getHistoryPageNumber]);

    useEffect(() => {
        if (getDocumentaryPageNumber <= 100) {
            getAllGenre(99, 99, "documentary");
        }
    }, [getDocumentaryPageNumber]);

    useEffect(() => {
        if (getFantasyPageNumber <= 100) {
            getAllGenre(14, 14, "fantasy");
        }
    }, [getFantasyPageNumber]);

    useEffect(() => {
        if (getCrimePageNumber <= 100) {
            getAllGenre(80, 80, "crime");
        }
    }, [getCrimePageNumber]);

    useEffect(() => {
        if (getMusicPageNumber <= 100) {
            getAllGenre(10402, 10402, "music");
        }
    }, [getMusicPageNumber]);

    return (
        <searchContext.Provider value={{ 
            getIsMessage, setIsMessage, getUserId, setUserId, getYourId, setYourId, getSelectedEmoji, setSelectedEmoji, 
            getUnknownTab, setUnknownTab, getActionList, setActionList, getThrillerList, setThrillerList, getComedyList, setComedyList,
            getHorrorList, setHorrorList, getFamilyList, setFamilyList, getMysteryList, setMysteryList, getAnimationList, setAnimationList, 
            getDramaList, setDramaList, getAdventureList, setAdventureList, getRomanceList, setRomanceList, getScienceFictionList, setScienceFictionList,
            getNewsList, setNewsList, getKidsList, setKidsList, getRealityList, setRealityList, getSoapList, setSoapList,
            getTalkList, setTalkList, getWarList, setWarList, getWesternList, setWesternList, getHistoryList, setHistoryList, 
            getDocumentaryList, setDocumentaryList, getFantasyList, setFantasyList, getCrimeList, setCrimeList, getMusicList, setMusicList,
            getVotedList, setVotedList, getOriginalActionList, setOriginalActionList, getOriginalThrillerList, setOriginalThrillerList,
            getOriginalComedyList, setOriginalComedyList, getOriginalHorrorList, setOriginalHorrorList, getOriginalFamilyList, setOriginalFamilyList,
            getOriginalMysteryList, setOriginalMysteryList, getOriginalAnimationList, setOriginalAnimationList, getOriginalDramaList, setOriginalDramaList,
            getOriginalAdventureList, setOriginalAdventureList, getOriginalRomanceList, setOriginalRomanceList, getOriginalScienceFictionList, setOriginalScienceFictionList,
            getOriginalNewsList, setOriginalNewsList, getOriginalKidsList, setOriginalKidsList, getOriginalRealityList, setOriginalRealityList, getOriginalSoapList, setOriginalSoapList,
            getOriginalTalkList, setOriginalTalkList, getOriginalWarList, setOriginalWarList, getOriginalWesternList, setOriginalWesternList, getOriginalHistoryList, setOriginalHistoryList, 
            getOriginalDocumentaryList, setOriginalDocumentaryList, getOriginalFantasyList, setOriginalFantasyList, getOriginalCrimeList, setOriginalCrimeList, getOriginalMusicList, setOriginalMusicList,
            getOriginalVotedList, setOriginalVotedList, getBackImages, setBackImages, getBackIndex, setBackIndex, getActionPageNumber, setActionPageNumber,
            getThrillerPageNumber, setThrillerPageNumber, getMysteryPageNumber, setMysteryPageNumber, getComedyPageNumber, setComedyPageNumber,
            getAnimationPageNumber, setAnimationPageNumber, getDramaPageNumber, setDramaPageNumber, getAdventurePageNumber, setAdventurePageNumber,
            getFamilyPageNumber, setFamilyPageNumber, getHorrorPageNumber, setHorrorPageNumber, getRomancePageNumber, setRomancePageNumber,
            getNewsPageNumber, setNewsPageNumber, getScienceFictionPageNumber, setScienceFictionPageNumber, getKidsPageNumber, setKidsPageNumber,
            getRealityPageNumber, setRealityPageNumber, getSoapPageNumber, setSoapPageNumber, getTalkPageNumber, setTalkPageNumber,
            getWarPageNumber, setWarPageNumber, getWesternPageNumber, setWesternPageNumber, getHistoryPageNumber, setHistoryPageNumber,
            getDocumentaryPageNumber, setDocumentaryPageNumber, getFantasyPageNumber, setFantasyPageNumber, getCrimePageNumber, setCrimePageNumber,
            getMusicPageNumber, setMusicPageNumber, getActionError, setActionError, getThrillerError, setThrillerError, getComedyError, setComedyError,
            getHorrorError, setHorrorError, getFamilyError, setFamilyError, getMysteryError, setMysteryError, getAnimationError, setAnimationError, 
            getDramaError, setDramaError, getAdventureError, setAdventureError, getRomanceError, setRomanceError, getScienceFictionError, 
            setScienceFictionError, getKidsError, setKidsError, getRealityError, setRealityError, getSoapError, setSoapError,
            getTalkError, setTalkError, getWarError, setWarError, getWesternError, setWesternError, getHistoryError, setHistoryError, getVotedError, setVotedError,
            getDocumentaryError, setDocumentaryError, getFantasyError, setFantasyError, getCrimeError, setCrimeError, getMusicError, setMusicError,
            getNewsError, setNewsError, getIsActionLoading, setIsActionLoading, getIsThrillerLoading, setIsThrillerLoading, getIsComedyLoading, setIsComedyLoading,
            getIsHorrorLoading, setIsHorrorLoading, getIsFamilyLoading, setIsFamilyLoading, getIsMysteryLoading, setIsMysteryLoading, getIsAnimationLoading, setIsAnimationLoading, 
            getIsDramaLoading, setIsDramaLoading, getIsAdventureLoading, setIsAdventureLoading, getIsRomanceLoading, setIsRomanceLoading, getIsScienceFictionLoading, setIsScienceFictionLoading,
            getIsNewsLoading, setIsNewsLoading, getIsKidsLoading, setIsKidsLoading, getIsRealityLoading, setIsRealityLoading, getIsSoapLoading, setIsSoapLoading,
            getIsTalkLoading, setIsTalkLoading, getIsWarLoading, setIsWarLoading, getIsWesternLoading, setIsWesternLoading, getIsHistoryLoading, setIsHistoryLoading, 
            getIsDocumentaryLoading, setIsDocumentaryLoading, getIsFantasyLoading, setIsFantasyLoading, getIsCrimeLoading, setIsCrimeLoading, getIsMusicLoading, setIsMusicLoading,
            getIsVotedLoading, setIsVotedLoading,
        }}>
            {children}
        </searchContext.Provider>
    );
};

export const useSearchContext = () => useContext(searchContext);